/* GeeClassic clone — interactions */
(function () {
  'use strict';

  /* ---------- Header: fixed transparent overlay at the top, solid once scrolled;
       hides on scroll-down / reveals on scroll-up; text + logo colour adapt to the
       background behind it (white over dark sections, black over light) ---------- */
  const header = document.querySelector('.header');
  if (header) {
    let lastY = window.scrollY;
    let ticking = false;

    /* Keep page content clearing the fixed header even when the announce bar
       wraps to two lines (mobile). Measures the real, uncollapsed height. */
    const hRow = header.querySelector('.header__row');
    const hAnn = header.querySelector('.announce');
    function measureHeader() {
      const total = (hRow ? hRow.offsetHeight : 0) + (hAnn ? hAnn.scrollHeight : 0);
      if (total > 0) document.documentElement.style.setProperty('--header-total', total + 'px');
    }
    measureHeader();
    window.addEventListener('load', measureHeader);
    window.addEventListener('resize', measureHeader, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measureHeader);

    // Sections that should flip the (transparent) header to white text.
    const darkZones = Array.prototype.slice.call(document.querySelectorAll('[data-header-theme="dark"]'));
    function themeBehindHeader() {
      const band = (header.offsetHeight || 80) * 0.5;   // sample mid-header
      for (let i = 0; i < darkZones.length; i++) {
        const r = darkZones[i].getBoundingClientRect();
        if (r.top <= band && r.bottom >= band) return 'dark';
      }
      return 'light';
    }
    function applyHeader() {
      const y = window.scrollY;
      const atTop = y <= 8;
      header.classList.toggle('is-top', atTop);
      header.classList.toggle('is-scrolled', !atTop);
      const hH = header.offsetHeight || 80;
      if (!atTop && y > lastY && y > hH + 60) header.classList.add('is-hidden');  // down
      else header.classList.remove('is-hidden');                                  // up / top
      // Solid header sits on cream → always dark text. Transparent header adapts.
      const dark = atTop && themeBehindHeader() === 'dark';
      header.classList.toggle('on-dark', dark);
      header.classList.toggle('on-light', !dark);
      lastY = y;
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(applyHeader); ticking = true; }
    }, { passive: true });
    window.addEventListener('resize', applyHeader, { passive: true });
    applyHeader();
  }

  /* ---------- Image fade-in on load (signature OC motion) ---------- */
  function fadeInImages(root) {
    (root || document).querySelectorAll('[data-fade]:not(.is-loaded)').forEach((el) => {
      const imgs = [...el.querySelectorAll('img')];
      const done = () => el.classList.add('is-loaded');
      if (!imgs.length) { done(); return; }
      let pending = imgs.filter((i) => !(i.complete && i.naturalWidth > 0)).length;
      if (pending === 0) { done(); return; }
      imgs.forEach((i) => {
        if (!(i.complete && i.naturalWidth > 0)) {
          const tick = () => { if (--pending <= 0) done(); };
          i.addEventListener('load', tick, { once: true });
          i.addEventListener('error', tick, { once: true });
        }
      });
      setTimeout(done, 2500); // safety net
    });
  }
  fadeInImages();
  window.addEventListener('load', () => fadeInImages());

  /* ---------- Hero sequenced entrance reveal (robust; never leaves hero hidden) ---------- */
  const heroEl = document.querySelector('.hero');
  if (heroEl) {
    heroEl.classList.add('anim');                 // only now do the overlay children start hidden
    const showHero = () => heroEl.classList.add('is-in');
    setTimeout(showHero, 80);                     // setTimeout fires even in background tabs (unlike rAF)
    window.addEventListener('load', () => setTimeout(showHero, 400)); // belt-and-suspenders
  }

  /* ---------- Mega-menu: backdrop dim + keyboard focus ---------- */
  document.querySelectorAll('.nav__item--has-menu').forEach((item) => {
    const link = item.querySelector('.nav__link');
    const setExpanded = (v) => { document.body.classList.toggle('menu-open', v); if (link) link.setAttribute('aria-expanded', v ? 'true' : 'false'); };
    item.addEventListener('mouseenter', () => setExpanded(true));
    item.addEventListener('mouseleave', () => setExpanded(false));
    item.addEventListener('focusin', () => setExpanded(true));
    item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget)) setExpanded(false); });
  });

  /* ---------- Search overlay ---------- */
  const search = document.querySelector('.overlay-search');
  const openSearch = () => { if (!search) return; search.classList.add('is-open'); setTimeout(() => (function(i){if(i)i.focus();})(search.querySelector('input')), 280); };
  const closeSearch = () => search && search.classList.remove('is-open');
  document.querySelectorAll('[data-open-search]').forEach((b) => b.addEventListener('click', openSearch));
  document.querySelectorAll('[data-close-search]').forEach((b) => b.addEventListener('click', closeSearch));
  if (search) search.addEventListener('click', (e) => { if (e.target === search) closeSearch(); });

  /* ---------- Cart drawer ---------- */
  const cart = document.querySelector('.drawer--cart');
  const scrim = document.querySelector('.scrim');
  const openCart = () => { cart.classList.add('is-open'); scrim.classList.add('is-open'); };
  const closeAll = () => {
    document.querySelectorAll('.drawer,.mdrawer').forEach((d) => d.classList.remove('is-open'));
    scrim.classList.remove('is-open');
  };
  document.querySelectorAll('[data-open-cart]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); openCart(); }));
  if (scrim) scrim.addEventListener('click', closeAll);
  document.querySelectorAll('[data-close]').forEach((b) => b.addEventListener('click', closeAll));

  /* ---------- Server cart = single source of truth (syncs on every page load + after changes,
       so the header count and drawer are always consistent regardless of page caching) ---------- */
  const geeMoney = (cents) => 'EGP ' + Math.round(cents / 100).toLocaleString('en-US');
  /* Last known server cart. The promo popup reads it so it never interrupts
     someone who already qualifies for the pair. */
  let gcLastCart = null;

  function geeRenderCart(c) {
    if (!c) return;
    gcLastCart = c;
    document.querySelectorAll('.cart-count').forEach((el) => { el.textContent = '(' + c.item_count + ')'; });
    const dc = document.querySelector('.cart-drawer-count'); if (dc) dc.textContent = c.item_count;
    const body = document.querySelector('[data-cart-body]');
    if (body) {
      if (!c.item_count) { body.classList.add('is-empty'); body.innerHTML = 'Your cart is empty.'; }
      else {
        body.classList.remove('is-empty');
        body.innerHTML = c.items.map((it) =>
          '<div class="cart-line"><img class="cart-line__img" src="' + (it.image || '') + '" alt="" width="64" height="80"><div class="cart-line__info">' +
          '<div class="cart-line__name">' + it.product_title + '</div>' +
          '<div class="cart-line__meta">' + (it.variant_title && !/Default/.test(it.variant_title) ? it.variant_title : '') + '</div>' +
          '<div class="cart-line__qty" data-line-key="' + it.key + '"><button type="button" class="qty-btn" data-qty-dec aria-label="Decrease quantity">&minus;</button><span class="qty-val">' + it.quantity + '</span><button type="button" class="qty-btn" data-qty-inc aria-label="Increase quantity">+</button></div>' +
          '<button type="button" class="cart-line__remove" data-remove-key="' + it.key + '">Remove</button></div>' +
          '<div class="cart-line__price">' + geeMoney(it.final_line_price) + '</div></div>').join('');
      }
    }
    const sub = document.querySelector('[data-cart-subtotal]'); if (sub) sub.textContent = geeMoney(c.total_price);

    /* Discount line. These numbers come straight from Shopify's cart, so what the
       drawer says was saved is exactly what checkout will charge — the theme
       never calculates a discount of its own. */
    const totals = document.querySelector('[data-cart-totals]');
    if (totals) {
      const saved = c.total_discount || 0;
      if (saved > 0) {
        totals.hidden = false;
        const orig = document.querySelector('[data-cart-original]');
        const disc = document.querySelector('[data-cart-discount]');
        const label = document.querySelector('[data-cart-discount-label]');
        if (orig) orig.textContent = geeMoney(c.original_total_price || c.total_price + saved);
        if (disc) disc.textContent = '−' + geeMoney(saved);
        // name the discount as Shopify named it, so the drawer matches checkout
        const titles = [];
        (c.items || []).forEach((it) => (it.line_level_discount_allocations || []).forEach((d) => {
          const t = d.discount_application && d.discount_application.title;
          if (t && titles.indexOf(t) === -1) titles.push(t);
        }));
        (c.cart_level_discount_applications || []).forEach((d) => {
          if (d.title && titles.indexOf(d.title) === -1) titles.push(d.title);
        });
        if (label && titles.length) label.textContent = titles.join(' · ');
      } else {
        totals.hidden = true;
      }
    }
    geeCartUpsell(c);
  }

  /* ---------- Pair offer: shared catalogue + sibling matching ---------- */
  const geeBundle = (() => {
    let cfg = null;
    try {
      const el = document.querySelector('[data-bundle-config]');
      if (el) cfg = JSON.parse(el.textContent);
    } catch (e) { cfg = null; }
    if (!cfg || !cfg.enabled || !Array.isArray(cfg.products)) return null;

    const byId = (id) => cfg.products.find((p) => p.id === id);
    // "the other colour in this size" = another product of the same type that
    // actually has that size in stock. No handles hardcoded anywhere.
    const findSibling = (productId, opt1, excludeIds) => {
      const me = byId(productId);
      if (!me) return null;
      const skip = excludeIds || [];
      const cands = cfg.products.filter((p) => p.id !== productId && p.type === me.type && skip.indexOf(p.id) === -1);
      for (const p of cands) {
        const v = p.variants.find((x) => x.opt1 === opt1 && x.available);
        if (v) return { product: p, variant: v };
      }
      return null;
    };
    return { cfg, byId, findSibling };
  })();

  function geeAddItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items })
    }).then((r) => r.json())
      .then(() => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()))
      .then((c) => { geeRenderCart(c); return c; });
  }

  /* ---------- Product page: "add the other colour in your size" ---------- */
  (function pdpBundle() {
    const box = document.querySelector('[data-bundle]');
    if (!box || !geeBundle) return;
    const thisId = parseInt(box.getAttribute('data-this-product'), 10);
    const nameEl = box.querySelector('[data-bundle-name]');
    const sizeEl = box.querySelector('[data-bundle-size]');
    const sizeWrap = box.querySelector('[data-bundle-size-wrap]');
    const addBtn = box.querySelector('[data-bundle-add]');
    const hint = box.querySelector('[data-bundle-hint]');
    const img = box.querySelector('.bundle__img');
    let pick = null;

    const selectedSize = () => {
      const active = document.querySelector('.pdp__sizes .pdp__size.is-active');
      return active ? active.getAttribute('data-size') : null;
    };
    const selectedVariant = () => {
      const input = document.querySelector('#pdp-form input[name="id"]');
      return input ? parseInt(input.value, 10) : null;
    };

    function refresh() {
      const size = selectedSize();
      if (!size) {
        // no size chosen yet — show the offer but make the next step obvious
        pick = null;
        if (sizeWrap) sizeWrap.hidden = true;
        if (hint) hint.hidden = false;
        if (addBtn) addBtn.disabled = false;
        return;
      }
      pick = geeBundle.findSibling(thisId, size);
      if (!pick) {
        box.hidden = true;
        return;
      }
      box.hidden = false;
      if (hint) hint.hidden = true;
      if (sizeWrap) { sizeWrap.hidden = false; }
      if (sizeEl) sizeEl.textContent = size;
      if (nameEl) nameEl.textContent = pick.product.shortTitle || pick.product.title;
      if (img && pick.product.image) img.src = pick.product.image;
      if (addBtn) addBtn.disabled = false;
    }

    // the size buttons are plain buttons, so watch the class the picker toggles
    const sizes = document.querySelector('.pdp__sizes');
    if (sizes) sizes.addEventListener('click', () => window.setTimeout(refresh, 0));
    refresh();

    if (addBtn) addBtn.addEventListener('click', async () => {
      const size = selectedSize();
      if (!size) {
        // nudge to the size picker rather than silently doing nothing
        (function(el){if(el)el.scrollIntoView({ behavior: 'smooth', block: 'center' });})(document.querySelector('.pdp__sizes'));
        (function(el){if(el)el.classList.add('pdp__sizes--nudge');})(document.querySelector('.pdp__sizes'));
        window.setTimeout(() => {var el=document.querySelector('.pdp__sizes');if(el)el.classList.remove('pdp__sizes--nudge');}, 1200);
        return;
      }
      const mine = selectedVariant();
      const currentSize = document.querySelector('.pdp__size.is-active');
      if (!mine || !pick || !currentSize || currentSize.disabled || currentSize.dataset.soldout) return;
      const label = addBtn.textContent;
      addBtn.disabled = true; addBtn.textContent = 'Adding…';
      try {
        await geeAddItems([{ id: mine, quantity: 1 }, { id: pick.variant.id, quantity: 1 }]);
        openCart();
      } catch (e) {
        addBtn.textContent = 'Could not add — try again';
        window.setTimeout(() => { addBtn.textContent = label; addBtn.disabled = false; }, 2000);
        return;
      }
      addBtn.textContent = label; addBtn.disabled = false;
    });
  })();

  /* ---------- Cart drawer: complete the pair ---------- */
  function geeCartUpsell(c) {
    const slot = document.querySelector('[data-cart-upsell]');
    if (!slot || !geeBundle || !c) return;
    const cfg = geeBundle.cfg;
    const qty = cfg.qty || 2;
    const inCart = (c.items || []).filter((it) => geeBundle.byId(it.product_id));
    const units = inCart.reduce((n, it) => n + it.quantity, 0);

    // only nudge when adding more actually completes a pair
    const remainder = units % qty;
    if (!units || remainder === 0) { slot.hidden = true; slot.innerHTML = ''; return; }
    const needed = qty - remainder;

    const last = inCart[inCart.length - 1];
    const me = geeBundle.byId(last.product_id);
    const size = (last.options_with_values && last.options_with_values[0] && last.options_with_values[0].value) || (last.variant_options && last.variant_options[0]) || last.variant_title;
    const owned = inCart.map((it) => it.product_id);

    // every colour that comes in this size — the one already in the cart
    // included, so a second white is as easy to add as the black. Colours not
    // yet in the cart are listed first.
    const options = cfg.products
      .filter((p) => me && p.type === me.type)
      .map((p) => ({ product: p, variant: p.variants.find((v) => v.opt1 === size) }))
      .filter((o) => o.variant)
      .sort((a, b) => (owned.indexOf(a.product.id) === -1 ? 0 : 1) - (owned.indexOf(b.product.id) === -1 ? 0 : 1));
    if (!options.length) { slot.hidden = true; slot.innerHTML = ''; return; }

    // wording comes from the offer snippet so it matches every other surface;
    // the arithmetic below is only a fallback for a theme without that field
    const saving = cfg.priceCents ? (last.price * qty) - cfg.priceCents : 0;
    const fallback = saving > 0 ? 'Add {n} more and save ' + geeMoney(saving) : 'Complete the pair';
    const eyebrow = String(cfg.nudge || fallback).replace('{n}', String(needed));

    slot.hidden = false;
    slot.innerHTML =
      '<p class="cart-upsell__eyebrow">' + eyebrow + '</p>' +
      '<div class="cart-upsell__opts">' + options.map((o) =>
        '<div class="cart-upsell__opt">' +
          '<img class="cart-upsell__img" src="' + (o.product.image || '') + '" alt="" width="40" height="50" loading="lazy">' +
          '<p class="cart-upsell__name">' + (o.product.shortTitle || o.product.title) + ' · ' + size + '</p>' +
          (o.variant.available
            ? '<button type="button" class="cart-upsell__add" data-upsell-add="' + o.variant.id + '">Add</button>'
            : '<button type="button" class="cart-upsell__add" disabled aria-label="' + (o.product.shortTitle || o.product.title) + ' ' + size + ' — Sold out">Sold out</button>') +
        '</div>').join('') +
      '</div>';
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-upsell-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    const id = parseInt(btn.getAttribute('data-upsell-add'), 10);
    if (!id) return;
    btn.disabled = true; btn.textContent = '…';
    try { await geeAddItems([{ id, quantity: 1 }]); }
    catch (err) { btn.disabled = false; btn.textContent = 'Add'; }
  });
  function syncServerCart() {
    if (!window.fetch || !window.Shopify) return Promise.resolve(null);
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()).then((c) => { geeRenderCart(c); return c; }).catch(() => null);
  }
  // Cart drawer line controls: quantity +/- and remove, via /cart/change.js
  const cartBodyEl = document.querySelector('[data-cart-body]');
  if (cartBodyEl && window.Shopify) {
    const changeLine = (key, quantity) => fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
    }).then((r) => r.json()).then(geeRenderCart).catch(() => {});
    cartBodyEl.addEventListener('click', (e) => {
      const rm = e.target.closest('.cart-line__remove');
      if (rm) { e.preventDefault(); const key = rm.getAttribute('data-remove-key'); if (key) changeLine(key, 0); return; }
      const step = e.target.closest('[data-qty-inc], [data-qty-dec]');
      if (step) {
        e.preventDefault();
        const wrap = step.closest('.cart-line__qty'); if (!wrap) return;
        const key = wrap.getAttribute('data-line-key');
        const cur = parseInt((wrap.querySelector('.qty-val') ? wrap.querySelector('.qty-val').textContent.trim() : ''), 10) || 1;
        const next = step.hasAttribute('data-qty-inc') ? cur + 1 : cur - 1; // change.js quantity 0 removes the line
        if (key) changeLine(key, next);
      }
    });
  }
  // Sync header + drawer to the real cart on every page load (fixes the stale "(0)" count).
  if (window.Shopify) syncServerCart();

  /* ---------- Mobile menu drawer ---------- */
  const mdrawer = document.querySelector('.mdrawer');
  document.querySelectorAll('[data-open-menu]').forEach((b) => b.addEventListener('click', () => {
    mdrawer.classList.add('is-open'); scrim.classList.add('is-open');
  }));
  document.querySelectorAll('.macc__btn').forEach((btn) => {
    btn.addEventListener('click', () => {
      const acc = btn.closest('.macc');
      const panel = acc.querySelector('.macc__panel');
      if (!panel) return;
      const open = acc.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
    });
  });

  /* ---------- Size chart modal ---------- */
  const sizechart = document.querySelector('.sizechart');
  const openSizechart = () => sizechart && sizechart.classList.add('is-open');
  const closeSizechart = () => sizechart && sizechart.classList.remove('is-open');
  document.querySelectorAll('[data-open-sizechart]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); openSizechart(); }));
  document.querySelectorAll('[data-close-sizechart]').forEach((b) => b.addEventListener('click', closeSizechart));
  if (sizechart) sizechart.addEventListener('click', (e) => { if (e.target === sizechart) closeSizechart(); });

  /* Size-guide tabs + size finder */
  if (sizechart) {
    const tabs = sizechart.querySelectorAll('[data-sg-tab]');
    const panes = sizechart.querySelectorAll('[data-sg-pane]');
    tabs.forEach((tab) => tab.addEventListener('click', () => {
      const key = tab.getAttribute('data-sg-tab');
      tabs.forEach((t) => { const on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
      panes.forEach((p) => { p.hidden = p.getAttribute('data-sg-pane') !== key; p.classList.toggle('is-active', p.getAttribute('data-sg-pane') === key); });
    }));

    /* Read the sizes straight off the rendered chart. The chart is editable in the
       theme editor, so a hardcoded copy here would silently start disagreeing with
       what the customer is looking at the first time someone edits a row. */
    const parseChart = () => {
      const table = sizechart.querySelector('.sg-chart');
      if (!table) return null;
      const sizes = [...table.querySelectorAll('thead th')].map((c) => c.textContent.trim()).slice(1);
      if (!sizes.length) return null;
      const rows = {};
      table.querySelectorAll('tbody tr').forEach((tr) => {
        const cells = [...tr.children].map((c) => c.textContent.trim());
        rows[(cells[0] || '').toLowerCase()] = cells.slice(1);
      });
      const rowFor = (frag) => {
        const key = Object.keys(rows).find((k) => k.indexOf(frag) > -1);
        return key ? rows[key] : null;
      };
      const heights = rowFor('height');
      const weights = rowFor('weight');
      const letters = rowFor('letter') || [];
      if (!heights || !weights) return null;
      // ranges are written "160–170" (en dash) or "160-170"
      const range = (txt) => {
        const n = String(txt || '').replace(/[–—]/g, '-').match(/\d+(?:\.\d+)?/g);
        if (!n) return null;
        return n.length > 1 ? [parseFloat(n[0]), parseFloat(n[1])] : [parseFloat(n[0]), parseFloat(n[0])];
      };
      const out = [];
      sizes.forEach((sz, i) => {
        const h = range(heights[i]);
        const w = range(weights[i]);
        if (h && w) out.push([sz, letters[i] || '', h[0], h[1], w[0], w[1]]);
      });
      return out.length ? out : null;
    };

    // Fallback only if the chart can't be read: [size, letter, hMin, hMax, wMin, wMax]
    const SIZES = parseChart() || [
      ['38', 'S', 160, 170, 55, 65],
      ['40', 'M', 170, 175, 65, 75],
      ['42', 'L', 175, 185, 75, 85],
      ['44', 'XL', 180, 185, 85, 95],
      ['46', 'XXL', 185, 190, 95, 105],
    ];

    // What the chart actually covers, plus a little grace at the edges.
    const H_TOL = 5;
    const W_TOL = 5;
    const cover = SIZES.reduce((a, s) => ({
      hLo: Math.min(a.hLo, s[2]), hHi: Math.max(a.hHi, s[3]),
      wLo: Math.min(a.wLo, s[4]), wHi: Math.max(a.wHi, s[5]),
    }), { hLo: Infinity, hHi: -Infinity, wLo: Infinity, wHi: -Infinity });

    /* Outside the chart there is no honest answer. The old scorer always returned
       a "closest" size, so someone at 200 kg was confidently told XXL — a guaranteed
       return and a lost customer. Say we don't carry it instead. */
    const outOfRange = (h, w) =>
      w < cover.wLo - W_TOL || w > cover.wHi + W_TOL ||
      h < cover.hLo - H_TOL || h > cover.hHi + H_TOL;

    const recommend = (h, w) => {
      // score each size by how well height + weight fall inside its range
      const mid = (a, b) => (a + b) / 2;
      const dist = (v, lo, hi) => (v < lo ? lo - v : v > hi ? v - hi : 0);
      let best = null;
      SIZES.forEach((s) => {
        const [, , hLo, hHi, wLo, wHi] = s;
        // weight weighted ~2x — it's the stronger signal for shirt fit
        const score = 2 * (dist(w, wLo, wHi) / 10) + dist(h, hLo, hHi) / 6 + Math.abs(w - mid(wLo, wHi)) / 40;
        if (!best || score < best.score) best = { s, score };
      });
      return best ? best.s : null;
    };
    const hEl = sizechart.querySelector('[data-sg-height]');
    const wEl = sizechart.querySelector('[data-sg-weight]');
    const resEl = sizechart.querySelector('[data-sg-result]');
    const calc = sizechart.querySelector('[data-sg-calc]');
    if (calc) calc.addEventListener('click', () => {
      const h = parseFloat(hEl ? hEl.value : NaN);
      const w = parseFloat(wEl ? wEl.value : NaN);
      if (!h || !w) {
        resEl.hidden = false; resEl.classList.remove('sg-result--none');
        resEl.innerHTML = 'Please enter both your height and weight.';
        return;
      }
      const noneMsg = sizechart.getAttribute('data-sg-none') || 'We don’t have a size that fits those measurements yet.';
      if (outOfRange(h, w)) {
        resEl.hidden = false; resEl.classList.add('sg-result--none');
        resEl.innerHTML =
          '<strong>' + noneMsg + '</strong><br>' +
          '<span style="color:var(--secondary);font-size:var(--fs-sm)">Our sizes currently fit ' +
          cover.hLo + '–' + cover.hHi + ' cm and ' + cover.wLo + '–' + cover.wHi + ' kg. ' +
          '<a href="/pages/contact" style="color:inherit;text-decoration:underline">Contact us</a>' +
          ' and we’ll tell you when we extend the range.</span>';
        return;
      }
      const r = recommend(h, w);
      if (!r) {
        resEl.hidden = false; resEl.classList.add('sg-result--none');
        resEl.innerHTML = '<strong>' + noneMsg + '</strong>';
        return;
      }
      resEl.hidden = false; resEl.classList.remove('sg-result--none');
      resEl.innerHTML = 'Your recommended size: <strong>' + r[0] + ' (' + r[1] + ')</strong><br><span style="color:var(--secondary);font-size:var(--fs-sm)">Based on a slim fit. Prefer it roomier? Size up.</span>';
    });
    [hEl, wEl].forEach((el) => { if (el) el.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); if (calc) calc.click(); } }); });
  }

  /* Esc closes everything */
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeAll(); closeSearch(); closeSizechart(); } });

  /* ---------- Splide: product carousels (supports multiple) ---------- */
  function initSplide() {
    if (typeof Splide === 'undefined') return;
    document.querySelectorAll('.bs-carousel').forEach((scope) => {
      const el = scope.querySelector('.splide');
      if (!el || el.classList.contains('is-active')) return;
      const pp = parseInt(el.getAttribute('data-perpage'), 10) || 3;
      const splide = new Splide(el, {
        perPage: pp, perMove: 1, gap: '1.5px', arrows: false, pagination: false,
        drag: true, snap: true, speed: 600, easing: 'cubic-bezier(.22,.61,.36,1)',
        breakpoints: { 1100: { perPage: pp }, 768: { perPage: 2 }, 560: { perPage: 1.3 } },
      });
      const prev = scope.querySelector('.bs-prev');
      const next = scope.querySelector('.bs-next');
      splide.on('mounted move updated', () => {
        const i = splide.index, end = splide.Components.Controller.getEnd();
        if (prev) { prev.disabled = i <= 0; prev.setAttribute('aria-disabled', i <= 0); }
        if (next) { next.disabled = i >= end; next.setAttribute('aria-disabled', i >= end); }
      });
      if (prev) prev.addEventListener('click', () => splide.go('<'));
      if (next) next.addEventListener('click', () => splide.go('>'));
      splide.mount();
    });
  }
  initSplide();

  /* ---------- Generic accordions (.acc) — product page, etc. ---------- */
  document.querySelectorAll('.acc__btn').forEach((btn) => {
    btn.addEventListener('click', () => {
      const acc = btn.closest('.acc');
      const panel = acc && acc.querySelector('.acc__panel');
      if (!panel) return;
      const open = acc.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
    });
  });

  /* ---------- Hero carousel: auto-advance, no controls ---------- */
  (function heroCarousel() {
    document.querySelectorAll('[data-hero-carousel]').forEach((root) => {
      const track = root.querySelector('[data-hero-track]');
      const slides = [...root.querySelectorAll('.hero__slide')];
      if (!track || slides.length < 2) return;

      const isSlide = root.getAttribute('data-transition') === 'slide';
      const autoplay = root.getAttribute('data-autoplay') === 'true';
      const interval = Math.max(1500, parseInt(root.getAttribute('data-interval'), 10) || 5000);
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      let i = 0;
      let timer = null;
      let visible = true;

      const show = (n) => {
        i = (n + slides.length) % slides.length;
        if (isSlide) track.style.transform = 'translateX(-' + i * 100 + '%)';
        slides.forEach((sl, k) => sl.classList.toggle('is-active', k === i));
      };
      const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
      const start = () => {
        stop();
        // a merchant can switch autoplay off, and reduced-motion users never get
        // movement they didn't ask for — both leave slide 1 showing
        if (!autoplay || reduced || !visible || slides.length < 2) return;
        timer = setInterval(() => show(i + 1), interval);
      };

      show(0);
      start();

      document.addEventListener('visibilitychange', () => {
        visible = !document.hidden;
        visible ? start() : stop();
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver((entries) => {
          entries.forEach((e) => { visible = e.isIntersecting; visible ? start() : stop(); });
        }, { threshold: 0.05 }).observe(root);
      }

      // theme editor: hold on whichever slide the merchant has selected
      document.addEventListener('shopify:block:select', (e) => {
        if (!root.contains(e.target)) return;
        stop();
        const n = slides.indexOf(e.target.closest('.hero__slide'));
        if (n > -1) show(n);
      });
      document.addEventListener('shopify:block:deselect', (e) => {
        if (root.contains(e.target)) start();
      });
    });
  })();

  /* ---------- Product gallery (thumbs ↔ stage) ---------- */
  /* ---------- PDP mobile swipe gallery: keep the thumb strip in sync with the track ---------- */
  (function pdpSwipeNav() {
    const gal = document.querySelector('.pdp__gallery--swipe');
    if (!gal) return;
    const track = gal.querySelector('.pdp__stage');
    const strip = gal.querySelector('[data-pdp-mthumbs]');
    const thumbs = strip ? [...strip.querySelectorAll('.pdp__mthumb')] : [];
    if (!track || !thumbs.length) return;
    let current = 0;
    const setActive = (i) => {
      if (i === current) return;
      current = i;
      thumbs.forEach((t, n) => t.classList.toggle('is-active', n === i));
      // keep the active thumb centred in the strip so long galleries stay navigable
      const t = thumbs[i];
      if (!t) return;
      const left = t.offsetLeft - (strip.clientWidth - t.clientWidth) / 2;
      strip.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
    };
    let ticking = false;
    track.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        const w = track.clientWidth || 1;
        setActive(Math.max(0, Math.min(thumbs.length - 1, Math.round(track.scrollLeft / w))));
        ticking = false;
      });
    }, { passive: true });
    thumbs.forEach((t, i) => t.addEventListener('click', () => {
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      setActive(i);
    }));
  })();

  const pdpStage = document.querySelector('.pdp__stage');
  if (pdpStage) {
    const stageImgs = [...pdpStage.querySelectorAll('img')];
    const thumbs = [...document.querySelectorAll('.pdp__thumb')];
    const select = (i) => {
      stageImgs.forEach((im, j) => im.classList.toggle('is-active', j === i));
      thumbs.forEach((t, j) => t.classList.toggle('is-active', j === i));
    };
    thumbs.forEach((t, i) => {
      t.addEventListener('click', () => select(i));
      t.addEventListener('mouseenter', () => select(i));
    });
    if (stageImgs.length && !pdpStage.querySelector('img.is-active')) select(0);
  }

  /* ---------- Product size selection (sets the Shopify variant id) ---------- */
  const pdpSizes = document.querySelector('.pdp__sizes');
  const pdpForm = document.getElementById('pdp-form');
  const variantInput = pdpForm ? pdpForm.querySelector('input[name="id"]') : null;
  function selectSize(btn) {
    if (!pdpSizes || !btn || btn.disabled || btn.dataset.soldout === 'true') return;
    pdpSizes.querySelectorAll('.pdp__size').forEach((x) => x.classList.remove('is-active'));
    btn.classList.add('is-active');
    if (variantInput && btn.dataset.variantId) variantInput.value = btn.dataset.variantId;
  }
  if (pdpSizes) {
    pdpSizes.querySelectorAll('.pdp__size').forEach((b) => b.addEventListener('click', () => b.dataset.soldout ? openRestock(b) : selectSize(b)));
  }

  /* ---------- Size-on-add sheet (Zara-style): submitting with no size slides up a
       size picker; choosing a size selects its variant and submits in one tap ---------- */
  let sizeSheet = null;
  function closeSizeSheet() { if (sizeSheet) sizeSheet.classList.remove('is-open'); if (scrim) scrim.classList.remove('is-open'); }
  function openSizeSheet() { buildSizeSheet(); if (sizeSheet) { sizeSheet.classList.add('is-open'); if (scrim) scrim.classList.add('is-open'); } }
  function buildSizeSheet() {
    if (sizeSheet || !pdpSizes) return;
    sizeSheet = document.createElement('div');
    sizeSheet.className = 'size-sheet';
    sizeSheet.setAttribute('role', 'dialog'); sizeSheet.setAttribute('aria-modal', 'true'); sizeSheet.setAttribute('aria-label', 'Select a size');
    sizeSheet.innerHTML = '<div class="size-sheet__panel"><div class="size-sheet__head"><span>Select a size</span><button type="button" class="size-sheet__x" aria-label="Close">&times;</button></div><div class="size-sheet__list"></div></div>';
    const list = sizeSheet.querySelector('.size-sheet__list');
    pdpSizes.querySelectorAll('.pdp__size').forEach((s) => {
      const low = s.disabled || s.dataset.soldout === 'true';
      const opt = document.createElement('button');
      opt.type = 'button';
      opt.className = 'size-sheet__opt' + (low ? ' is-soldout' : '');
      if (low) { opt.setAttribute('aria-haspopup', 'dialog'); opt.setAttribute('aria-label', s.dataset.size + ' — Sold out. Notify me'); }
      opt.innerHTML = '<span class="size-sheet__sz">' + s.getAttribute('data-size') + '</span><span class="size-sheet__hint">' + (low ? 'Sold out · Notify me' : 'In stock') + '</span>';
      opt.addEventListener('click', () => {
        if (low) { closeSizeSheet(); openRestock(s); return; }
        selectSize(s);
        closeSizeSheet();
        if (pdpForm) { pdpForm.requestSubmit ? pdpForm.requestSubmit() : pdpForm.dispatchEvent(new Event('submit', { cancelable: true })); }
      });
      list.appendChild(opt);
    });
    sizeSheet.addEventListener('click', (e) => { if (e.target === sizeSheet) closeSizeSheet(); });
    sizeSheet.querySelector('.size-sheet__x').addEventListener('click', closeSizeSheet);
    document.body.appendChild(sizeSheet);
  }

  /* Sold-out sizes open a contact request, never select a cart variant. */
  const restockDialog = document.querySelector('[data-restock-dialog]');
  let restockTrigger = null;
  function openRestock(trigger) {
    if (!restockDialog) return;
    restockTrigger = trigger || document.activeElement;
    const select = restockDialog.querySelector('select');
    if (select && trigger && trigger.dataset.variantId) {
      const option = [...select.options].find(o => o.dataset.variantId === trigger.dataset.variantId);
      if (option) select.value = option.value;
    }
    if (!restockDialog.open) restockDialog.showModal();
  }
  if (restockDialog) {
    document.querySelectorAll('[data-open-restock]').forEach(b => b.addEventListener('click', () => openRestock(b)));
    restockDialog.querySelector('[data-close-restock]').addEventListener('click', () => restockDialog.close());
    restockDialog.addEventListener('click', e => {
      if (e.target !== restockDialog) return;
      const r = restockDialog.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) restockDialog.close();
    });
    restockDialog.addEventListener('close', () => { if (restockTrigger) restockTrigger.focus(); });
    if (restockDialog.querySelector('[data-restock-result]')) openRestock();
  }

  /* ---------- Product colour swatches (swap gallery hero + label) ---------- */
  const swatchWrap = document.querySelector('.pdp__swatches');
  if (swatchWrap) {
    const colorLabel = document.getElementById('pdp-color');
    const stageActive = () => document.querySelector('.pdp__stage img.is-active') || document.querySelector('.pdp__stage img');
    swatchWrap.querySelectorAll('.pdp__swatch').forEach((sw) => {
      sw.addEventListener('click', () => {
        swatchWrap.querySelectorAll('.pdp__swatch').forEach((x) => x.classList.remove('is-active'));
        sw.classList.add('is-active');
        const img = stageActive();
        if (img && sw.dataset.img) img.src = sw.dataset.img;
        if (colorLabel && sw.dataset.color) colorLabel.textContent = sw.dataset.color;
      });
    });
  }

  /* ---------- Autoplay/loop video via IntersectionObserver ---------- */
  const vids = document.querySelectorAll('video[data-auto]');
  if (vids.length) {
    const vio = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        const v = en.target;
        if (en.isIntersecting) { v.play().catch(() => {}); } else { v.pause(); }
      });
    }, { threshold: 0.25 });
    vids.forEach((v) => vio.observe(v));
  }

  /* ---------- Scroll reveal ---------- */
  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length) {
    const show = (el) => el.classList.add('in');
    if ('IntersectionObserver' in window) {
      const rio = new IntersectionObserver((entries, obs) => {
        entries.forEach((en) => { if (en.isIntersecting) { show(en.target); obs.unobserve(en.target); } });
      }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
      reveals.forEach((r) => {
        // reveal immediately if already in/near viewport on load
        const top = r.getBoundingClientRect().top;
        if (top < window.innerHeight * 1.1) show(r); else rio.observe(r);
      });
    } else {
      reveals.forEach(show);
    }
    // Safety net: never leave content hidden (IO blocked / odd browsers)
    window.addEventListener('load', () => setTimeout(() => reveals.forEach(show), 1500));
  }

  /* ---------- Cart engine (demo) + free-gift progress ---------- */
  const GIFT_THRESHOLD = 2500;
  const cartItems = [];
  const fmt = (n) => 'EGP ' + Math.round(n).toLocaleString('en-US');
  const parsePrice = (s) => parseFloat(String(s).replace(/[^0-9.]/g, '')) || 0;

  function renderCart() {
    const count = cartItems.reduce((n, i) => n + i.qty, 0);
    const subtotal = cartItems.reduce((n, i) => n + i.price * i.qty, 0);
    document.querySelectorAll('.cart-count').forEach((el) => { el.textContent = '(' + count + ')'; });
    const dc = document.querySelector('.cart-drawer-count'); if (dc) dc.textContent = count;
    const body = document.querySelector('[data-cart-body]');
    if (body) {
      if (!cartItems.length) {
        body.classList.add('is-empty');
        body.innerHTML = 'Your cart is empty.';
      } else {
        body.classList.remove('is-empty');
        body.innerHTML = cartItems.map((i) =>
          '<div class="cart-line"><img class="cart-line__img" src="' + i.img + '" alt=""><div class="cart-line__info">' +
          '<div class="cart-line__name">' + i.name + '</div><div class="cart-line__meta">' + (i.size ? 'Size ' + i.size + ' · ' : '') + 'Qty ' + i.qty + '</div></div>' +
          '<div class="cart-line__price">' + fmt(i.price * i.qty) + '</div></div>'
        ).join('');
      }
    }
    const sub = document.querySelector('[data-cart-subtotal]'); if (sub) sub.textContent = fmt(subtotal);
  }

  function addToCart(item) {
    const key = item.name + '|' + (item.size || '');
    const existing = cartItems.find((i) => (i.name + '|' + (i.size || '')) === key);
    if (existing) existing.qty += 1; else cartItems.push({ ...item, qty: 1 });
    renderCart();
    openCart();
  }

  function bindAddToCart(scope) {
    (scope || document).querySelectorAll('[data-add-to-cart]').forEach((btn) => {
      if (btn.__bound) return; btn.__bound = true;
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const selSize = document.querySelector('.pdp__size.is-active');
        addToCart({
          name: btn.getAttribute('data-name') || 'Item',
          price: parsePrice(btn.getAttribute('data-price')),
          img: btn.getAttribute('data-img') || '',
          size: btn.getAttribute('data-size') || (selSize ? selSize.getAttribute('data-size') : ''),
        });
      });
    });
  }
  // Demo cart only runs on the static preview; on the Shopify theme the server cart (syncServerCart) is authoritative.
  if (!window.Shopify) { bindAddToCart(); renderCart(); }

  /* ---------- Shopify AJAX cart (theme only; progressive enhancement) ---------- */
  const shopForm = document.querySelector('form#pdp-form, form[action*="/cart/add"]');
  if (shopForm && window.fetch && window.Shopify) {
    const sMoney = (c) => 'EGP ' + Math.round(c / 100).toLocaleString('en-US');
    function renderShopifyCart(c) {
      document.querySelectorAll('.cart-count').forEach((el) => { el.textContent = '(' + c.item_count + ')'; });
      const dc = document.querySelector('.cart-drawer-count'); if (dc) dc.textContent = c.item_count;
      const body = document.querySelector('[data-cart-body]');
      if (body) {
        if (!c.item_count) { body.classList.add('is-empty'); body.innerHTML = 'Your cart is empty.'; }
        else {
          body.classList.remove('is-empty');
          body.innerHTML = c.items.map((it) =>
            '<div class="cart-line"><img class="cart-line__img" src="' + (it.image || '') + '" alt=""><div class="cart-line__info">' +
            '<div class="cart-line__name">' + it.product_title + '</div><div class="cart-line__meta">' +
            (it.variant_title && !/Default/.test(it.variant_title) ? it.variant_title + ' · ' : '') + 'Qty ' + it.quantity + '</div></div>' +
            '<div class="cart-line__price">' + sMoney(it.final_line_price) + '</div></div>').join('');
        }
      }
      const sub = document.querySelector('[data-cart-subtotal]'); if (sub) sub.textContent = sMoney(c.total_price);
    }
    shopForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      // Zara-style: if sizes exist and none is chosen, slide up the size sheet instead of adding.
      if (pdpSizes && !pdpSizes.querySelector('.pdp__size.is-active')) { openSizeSheet(); return; }
      const chosen = pdpSizes && pdpSizes.querySelector('.pdp__size.is-active');
      if (chosen && (chosen.disabled || chosen.dataset.soldout === 'true')) return;
      const errorBox = shopForm.querySelector('[data-cart-error]');
      if (errorBox) errorBox.hidden = true;
      try {
        const add = await fetch('/cart/add.js', { method: 'POST', body: new FormData(shopForm), headers: { Accept: 'application/json' } });
        if (!add.ok) {
          const failure = await add.json();
          throw new Error(failure.description || 'This size is no longer available. Please select another size.');
        }
        const c = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
        geeRenderCart(c);
        openCart();
      } catch (err) {
        if (errorBox) { errorBox.textContent = err.message || 'Could not add this item. Please try again.'; errorBox.hidden = false; }
      } // Do not retry an uncertain cart write or bypass the availability guard.
    });
  }

  /* ---------- Sticky add-to-cart (mobile PDP) ---------- */
  const mainAtc = document.querySelector('.pdp__atc');
  if (mainAtc) {
    let bar = document.querySelector('.sticky-atc');
    if (!bar) {
      // preview: build the bar + wire demo add-to-cart
      const name = mainAtc.getAttribute('data-name') || (document.querySelector('.pdp__title') ? document.querySelector('.pdp__title').textContent.trim() : '') || 'Item';
      const price = mainAtc.getAttribute('data-price') || (document.querySelector('.pdp__price') ? document.querySelector('.pdp__price').textContent.trim() : '') || '';
      const img = mainAtc.getAttribute('data-img') || (document.querySelector('.pdp__stage img') ? document.querySelector('.pdp__stage img').getAttribute('src') : '') || '';
      bar = document.createElement('div');
      bar.className = 'sticky-atc';
      bar.innerHTML = '<div class="sticky-atc__info"><div class="sticky-atc__name">' + name + '</div><div class="sticky-atc__price">' + price + '</div></div>' +
        '<button class="btn" data-add-to-cart data-name="' + name + '" data-price="' + price + '" data-img="' + img + '">Add to cart</button>';
      document.body.appendChild(bar);
      bindAddToCart(bar);
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { bar.classList.toggle('show', !en.isIntersecting); });
    }, { threshold: 0 });
    io.observe(mainAtc);
  }

  /* ---------- Shared-element page transition: clicked product image → PDP hero ---------- */
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a.tile');
    if (!a) return;
    // clear any stale names, tag the clicked image so the cross-document VT can match it
    document.querySelectorAll('[style*="view-transition-name"]').forEach((el) => { el.style.viewTransitionName = ''; });
    const img = a.querySelector('.img1') || a.querySelector('img');
    if (img) img.style.viewTransitionName = 'product-hero';
  }, true);

  /* ---------- Mobile only: auto-swap home product image (front ↔ back) every 3s ---------- */
  if (window.matchMedia && window.matchMedia('(max-width: 768px)').matches) {
    document.querySelectorAll('.feat-hero .tile').forEach((t, i) => {
      if (!t.querySelector('.img2')) return;
      setTimeout(() => setInterval(() => t.classList.toggle('show-2'), 3000), i * 1500);
    });
  }

  /* ---------- Running offer strip ----------
     The CSS animates the track to -50%, which is only seamless if the track holds
     an EVEN number of identical groups and is wider than the viewport. Liquid
     renders one group; this clones it to fit, then sets the duration from a
     px/second speed so a long message doesn't race past faster than a short one. */
  (function promoMarquee() {
    const bars = document.querySelectorAll('[data-mq]');
    if (!bars.length) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    function build(bar) {
      const track = bar.querySelector('[data-mq-track]');
      const group = bar.querySelector('[data-mq-group]');
      if (!track || !group) return;
      while (track.children.length > 1) track.removeChild(track.lastChild);
      if (reduce.matches) { bar.classList.add('is-static'); track.style.removeProperty('--mq-dur'); return; }
      bar.classList.remove('is-static');
      const w = group.getBoundingClientRect().width;
      if (!w) return;
      const speed = parseFloat(bar.getAttribute('data-mq-speed')) || 60;
      let copies = Math.max(2, Math.ceil((bar.clientWidth * 2) / w));
      if (copies % 2) copies += 1;                                  // even → seamless loop
      for (let i = 1; i < copies; i++) track.appendChild(group.cloneNode(true));
      track.style.setProperty('--mq-dur', (((copies / 2) * w) / speed).toFixed(2) + 's');
    }

    const buildAll = () => bars.forEach(build);
    buildAll();
    // Webfonts land after first paint and change the measured width.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(buildAll);
    let t = null;
    window.addEventListener('resize', () => { clearTimeout(t); t = setTimeout(buildAll, 200); }, { passive: true });
    if (reduce.addEventListener) reduce.addEventListener('change', buildAll);
    // Don't burn a compositor loop on a tab nobody is looking at.
    document.addEventListener('visibilitychange', () => {
      bars.forEach((b) => b.classList.toggle('is-paused', document.hidden));
    });
  })();

  /* ---------- Offer popup ----------
     Everything here is about NOT being annoying: it waits for a signal of
     interest (dwell, scroll depth, or the cursor leaving the window), shows once
     per frequency window, and stands down whenever it would interrupt — another
     overlay is open, or the customer already has enough for the pair. */
  (function promoModal() {
    const dlg = document.querySelector('[data-promo-modal]');
    if (!dlg || typeof dlg.showModal !== 'function') return;

    const design = !!(window.Shopify && window.Shopify.designMode);
    const KEY = 'gc_promo_seen';
    const freq = dlg.getAttribute('data-freq') || 'session';
    const delay = parseFloat(dlg.getAttribute('data-delay'));
    const scrollAt = parseFloat(dlg.getAttribute('data-scroll'));
    const exitOn = dlg.getAttribute('data-exit') === 'true';
    let done = false;

    /* How often one person sees it. 'session' = once per browsing session (dies
       with the tab); a number = that many minutes of cooldown; '0' = no cap, for
       testing. Both stores are written either way, so changing the setting later
       behaves sensibly instead of re-showing to everyone.
       In the theme editor it always shows, so the merchant can style it. */
    function suppressed() {
      if (design || freq === '0') return false;
      try {
        if (freq === 'session') return !!window.sessionStorage.getItem(KEY);
        const mins = parseFloat(freq);
        if (!(mins > 0)) return false;
        const seen = parseFloat(window.localStorage.getItem(KEY));
        return !!seen && Date.now() - seen < mins * 60000;
      } catch (e) {
        return false;   // private mode: better to show once than never
      }
    }
    function remember() {
      try { window.sessionStorage.setItem(KEY, '1'); } catch (e) { /* ignore */ }
      try { window.localStorage.setItem(KEY, String(Date.now())); } catch (e) { /* ignore */ }
    }
    if (suppressed()) return;

    const qty = (geeBundle && geeBundle.cfg && geeBundle.cfg.qty) || 2;
    function offerMet() {
      if (!gcLastCart || !geeBundle) return false;
      const units = (gcLastCart.items || [])
        .filter((it) => geeBundle.byId(it.product_id))
        .reduce((n, it) => n + it.quantity, 0);
      return units >= qty;
    }
    // .scrim is raised by the cart drawer, the mobile menu and the size sheet alike.
    const busy = () => !!document.querySelector('.scrim.is-open, .overlay-search.is-open');

    function open() {
      // re-check the cap: another tab may have shown it during our delay
      if (done || dlg.open || busy() || offerMet() || suppressed()) return;
      done = true;
      remember();
      dlg.showModal();
      document.documentElement.classList.add('has-modal');
      window.requestAnimationFrame(() => dlg.classList.add('is-open'));
    }
    function close() {
      dlg.classList.remove('is-open');
      document.documentElement.classList.remove('has-modal');
      window.setTimeout(() => { if (dlg.open) dlg.close(); }, 300);
    }

    dlg.addEventListener('click', (e) => { if (!e.target.closest('.pmodal__inner')) close(); });
    dlg.querySelectorAll('[data-promo-close]').forEach((b) => b.addEventListener('click', close));
    // Esc: let it animate out instead of vanishing.
    dlg.addEventListener('cancel', (e) => { e.preventDefault(); close(); });
    // Following the CTA counts as engagement, not a dismissal — close quietly.
    // both CTAs: the button and the image pair are links to the offer
    dlg.querySelectorAll('[data-promo-cta]').forEach((cta) => cta.addEventListener('click', () => {
      document.documentElement.classList.remove('has-modal');
    }));

    /* The shirts are lazy, and a lazy image inside a closed <dialog> is never
       fetched — so the popup would open blank for a beat. Warm them once the page
       itself has settled, which keeps them off the critical path either way. */
    window.setTimeout(() => {
      dlg.querySelectorAll('.pmodal__pair img').forEach((img) => {
        const pre = new Image();
        if (img.srcset) pre.srcset = img.srcset;
        pre.src = img.src;
      });
    }, 2500);

    if (design) { window.setTimeout(open, 800); return; }

    if (delay >= 0) window.setTimeout(open, Math.max(delay, 0) * 1000);
    if (scrollAt > 0) {
      const onScroll = () => {
        const h = document.documentElement.scrollHeight - window.innerHeight;
        if (h > 0 && (window.scrollY / h) * 100 >= scrollAt) {
          window.removeEventListener('scroll', onScroll);
          open();
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
    }
    // Exit intent is a pointer behaviour; on touch it would fire at random.
    if (exitOn && window.matchMedia('(hover: hover)').matches) {
      document.addEventListener('mouseout', (e) => {
        if (!e.relatedTarget && e.clientY <= 0) open();
      });
    }
  })();
})();
